import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CommonMixin from "@/core/plugins/common-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ProductMixin from "@/core/plugins/product-mixin";
import { POST, GET, PUT, CLEAR_ERROR, UPDATE_ERROR } from "@/core/services/store/request.module";
import ProductCreate from "@/view/pages/product/partials/Create.vue";
export default {
  mixins: [CommonMixin, ProductMixin],
  name: "product-create",
  title: "Create Product",
  data: function data() {
    return {
      barcode: null,
      barcodeDialog: false,
      updateMode: false,
      barcodeSetting: {
        prefix_string: null,
        next_number: null,
        number_length: null
      },
      productCreate: null,
      productId: null,
      duplicateId: null
    };
  },
  components: {
    ProductCreate: ProductCreate
  },
  beforeUpdate: function beforeUpdate() {
    this.$store.dispatch(CLEAR_ERROR);
  },
  methods: {
    updateProduct: function updateProduct(param) {
      this.productCreate = param;
    },
    getProduct: function getProduct(productId) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (productId && productId > 0) {
          _this.$store.dispatch(GET, {
            url: "product/" + productId
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (error) {
            reject(error);
          });
        } else {
          resolve({});
        }
      });
    },
    createWarrantyEntity: function createWarrantyEntity() {
      var _this = this;

      return new Promise(function (resolve) {
        var warrantyFormData = _this.lodash.compact(_this.lodash.map(_this.productCreate.warranty, function (param) {
          if (param.field && param.value) {
            return param;
          }
        }));

        if (_this.lodash.isEmpty(warrantyFormData) === false) {
          _this.formLoading = true;

          _this.$store.dispatch(POST, {
            url: "product/" + _this.productId + "/entity",
            data: {
              type: 1,
              entities: warrantyFormData
            }
          }).then(function () {
            resolve(true);
          }).catch(function (error) {
            _this.logError(error);
          }).finally(function () {
            _this.formLoading = false;
          });
        } else {
          resolve(true);
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this = this;

      if (!_this.$refs.productForm.validate()) {
        return false;
      }

      _this.formLoading = true;

      _this.$store.dispatch(CLEAR_ERROR, {});

      var requestType = POST;
      var requestURL = "product";

      if (_this.productId && _this.productId > 0) {
        requestType = PUT;
        requestURL = "product/" + _this.productId;
      }

      _this.$store.dispatch(requestType, {
        url: requestURL,
        data: _this.productCreate
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.productId = response.data ? response.data.id : null;
                  _context.next = 3;
                  return _this.createWarrantyEntity();

                case 3:
                  _this.$router.push(_this.getDefaultRoute("product", {
                    query: {
                      status: "all"
                    }
                  }));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.formLoading = false;
      });
    },
    loadContent: function loadContent() {
      var _this = this;

      _this.getProduct(_this.productId).then(function (response) {
        if (_this.lodash.isEmpty(response) === false) {
          _this.$store.dispatch(SET_BREADCRUMB, [{
            title: "Product",
            route: "product"
          }, {
            title: "Update"
          }]);

          _this.barcode = response.barcode;
          _this.productCreate = {
            name: response.name,
            reference: response.reference,
            sku: response.sku,
            upc: response.upc,
            ean: response.ean,
            isbn: response.isbn,
            images: response.images,
            product_images: response.product_images,
            part_number: response.part_number,
            hsn_code: response.hsn_code,
            serial_number: response.serial_number,
            description: response.description,
            directory: response.directory,
            supplier: response.supplier ? response.supplier.id : null,
            brand: response.brand ? response.brand.id : null,
            manufacturer: response.manufacturer ? response.manufacturer.id : null,
            category: response.category ? response.category.id : null,
            unit: response.unit ? response.unit.id : null,
            tax: response.tax ? response.tax.id : null,
            tax_exemption: response.tax_exemption ? response.tax_exemption.id : null,
            accounting: response.accounting,
            product_type: response.product_type,
            purchase_cost: response.purchase_cost,
            selling_cost: response.selling_cost,
            length: response.length,
            width: response.width,
            height: response.height,
            weight: response.weight,
            taxable: response.is_taxable,
            sellable: response.is_sellable,
            confirmed: response.is_confirmed,
            track_batch: response.track_batch,
            manage_stock: response.manage_stock,
            reorder_level: response.reorder_level,
            initial_stock: response.initial_stock,
            charges: response.charges,
            warranty: _this.lodash.compact(_this.lodash.map(response.warranty_data, function (param) {
              if (param.field && param.value) {
                return {
                  id: param.id,
                  field: param.field,
                  value: param.value
                };
              }
            }))
          };
        }
      }).catch(function (error) {
        _this.$store.dispatch(UPDATE_ERROR, error);
      });
    },
    loadDuplicateContent: function loadDuplicateContent() {
      var _this = this;

      _this.getProduct(_this.duplicateId).then(function (response) {
        if (_this.lodash.isEmpty(response) === false) {
          _this.productCreate = {
            name: response.name,
            reference: response.reference,
            sku: response.sku,
            upc: response.upc,
            ean: response.ean,
            isbn: response.isbn,
            images: response.images,
            //product_images: response.product_images,
            part_number: response.part_number,
            hsn_code: response.hsn_code,
            description: response.description,
            directory: response.directory,
            supplier: response.supplier ? response.supplier.id : null,
            brand: response.brand ? response.brand.id : null,
            manufacturer: response.manufacturer ? response.manufacturer.id : null,
            category: response.category ? response.category.id : null,
            unit: response.unit ? response.unit.id : null,
            tax: response.tax ? response.tax.id : null,
            tax_exemption: response.tax_exemption ? response.tax_exemption.id : null,
            accounting: response.accounting,
            product_type: response.product_type,
            purchase_cost: response.purchase_cost,
            selling_cost: response.selling_cost,
            length: response.length,
            width: response.width,
            height: response.height,
            weight: response.weight,
            taxable: response.is_taxable,
            sellable: response.is_sellable,
            confirmed: response.is_confirmed,
            track_batch: response.track_batch,
            manage_stock: response.manage_stock,
            reorder_level: response.reorder_level,
            charges: response.charges,
            warranty: _this.lodash.compact(_this.lodash.map(response.warranty_data, function (param) {
              if (param.field && param.value) {
                return {
                  id: null,
                  field: param.field,
                  value: param.value
                };
              }
            }))
          };
        }
      }).catch(function (error) {
        _this.$store.dispatch(UPDATE_ERROR, error);
      });
    }
  },
  created: function created() {
    var _this = this;

    _this.productId = _this.lodash.toSafeInteger(_this.$route.params.id);
    _this.duplicateId = _this.lodash.toSafeInteger(_this.$route.query.duplicate);
  },
  mounted: function mounted() {
    var _this = this;

    _this.$store.dispatch(SET_BREADCRUMB, [{
      title: "Product",
      route: "product"
    }, {
      title: "Create"
    }]);

    if (_this.$route.name == "admin.product.update" || _this.$route.name == "engineer.product.update") {
      _this.updateMode = true;

      if (_this.productId <= 0) {
        _this.$router.go(-1);
      }

      _this.loadContent();
    }

    if (_this.duplicateId > 0) {
      _this.loadDuplicateContent();
    }
  }
};